import { useContext } from "react";

import { FindingsContext } from "../../contexts/user/FindingsContext";

const useFindings = () => {
  const context = useContext(FindingsContext);
  return context;
};

export default useFindings;
